import { createStyles, makeStyles } from "@material-ui/core";
import {
    RelodeTheme,
    Text,
    TilesSection as CoreTilesSection,
} from "@relode/core";
import classnames from "classnames";
import * as React from "react";

export const useDashboardTileSectionStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            title: {
                marginBottom: theme.spacing(1),
                // HACK: this styles the title whether a string or passed in...
                [theme.breakpoints.down("sm")]: {
                    "& h2": {
                        fontSize: "20px",
                        lineHeight: "25px",
                    },
                },
            },
            tilesSection: {
                display: "flex",
                flexDirection: "column",
                paddingBottom: theme.spacing(2),
                [theme.breakpoints.down("sm")]: {
                    paddingBottom: 0,
                },
            },
            tilesGrid: {
                gridTemplateColumns: "repeat(auto-fit, minmax(144px, 1fr))",
            },
            gridBase: {
                display: "grid",
                gridRowGap: theme.spacing(2),
                gridColumnGap: theme.spacing(2),
                [theme.breakpoints.down("sm")]: {
                    gridRowGap: 0,
                    gridColumnGap: 0,
                    padding: 0,
                },
            },
            fitContent: {
                [theme.breakpoints.up("md")]: {
                    width: "max-content",
                },
                minWidth: 320,
            },
            noPadding: {
                padding: 0,
            },
        }),
    { name: "DashboardTilesSection" }
);

export const DashboardTileSection = React.memo(
    (props: {
        children: React.ReactNode;
        usePaper?: boolean;
        title?: string | React.ReactNode;
        className?: string;
        fitContent?: boolean;
        noPadding?: boolean;
    }) => {
        const classes = useDashboardTileSectionStyles({});
        let titleComponent;
        if (typeof props.title === "string") {
            titleComponent = <Text variant="h2">{props.title}</Text>;
        } else {
            titleComponent = props.title;
        }
        return (
            <div
                className={classnames(classes.tilesSection, {
                    [classes.fitContent]: !!props.fitContent,
                })}
            >
                {props.title !== undefined ? (
                    <div className={classes.title}>{titleComponent}</div>
                ) : null}
                <CoreTilesSection
                    classes={{
                        content: classnames(
                            classes.gridBase,
                            classes.tilesGrid,
                            {
                                [classes.noPadding]: !!props.noPadding,
                            }
                        ),
                    }}
                    usePaper={props.usePaper}
                >
                    {props.children}
                </CoreTilesSection>
            </div>
        );
    }
);
